/* eslint-disable */
import React from "react";
import { CalendarMonth } from '../../../controls/CalendarMonth';
import { CalendarHierarchy, InputCalendarHierarchyItem } from '../../../controls/CalendarHierarchy';
import { ICalendarItem, useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { equal } from "../../../../../shared";

export const CalendarHierarchyControl: React.FC = () => {
    const [controlItems, setControlItems] = React.useState<InputCalendarHierarchyItem[] | undefined>();
    const [dictItems] = useDictionary(dictionaryService, "calendar-origin");
    const [, setCalendarValue] = useParameter<number[]>("@calendar");
    const [calendarDisplayValue, setCalendarDisplayValue] = useParameter<number[]>("@calendar_display");
    const [yearFrequency, monthFrequency, weekFrequency] = [1, 4, 7];

    React.useEffect(function updateControlsItemsByDictionaryItems() {
        const candiatesControlItems = dictItems?.map<InputCalendarHierarchyItem & { frequency: number }>(item => ({
            id: Number(item.id),
            parent: item.getValue<number>('parent'),
            name: item.getValue<string>('name') || '',
            frequency: item.getValue<number>('frequencyId')!,
        }));

        const [minYear, maxYear] = [120040101, Number(`1${new Date().getFullYear()}0101`)];
        const nextControlItems = candiatesControlItems?.reduce((result, item) => {
            const itemId = item.id as number;
            if (item.frequency === yearFrequency && itemId >= minYear && itemId <= maxYear) {
                result.push(item);
            } else if (item.frequency === monthFrequency) {
                const paretQuartal = dictItems?.find(dictItem => equal(+dictItem.id, item.parent));
                const parentYearId = paretQuartal?.getValue<number>('parent')!;
                if (parentYearId >= minYear && parentYearId <= maxYear) {
                    item.parent = parentYearId;
                    result.push(item);
                }
            } else if (item.frequency === weekFrequency) {
                const paretMonth = result?.find(resultItem => equal(Number(resultItem.id), item.parent));
                if (paretMonth) {
                    result.push(item);
                }
            }
            return result;
        }, [] as typeof candiatesControlItems);

        setControlItems(nextControlItems);
    }, [dictItems]);

    const handlerChange = React.useCallback((value: unknown) => {
        const weeksOrMonthesOrYearsIds = value as number[];
        setCalendarDisplayValue(weeksOrMonthesOrYearsIds);

        const weeksIds = weeksOrMonthesOrYearsIds.flatMap(weekOrMonthOrYearId => {
            const firstCharacter = weekOrMonthOrYearId.toString().slice(0, 1);
            const frequency = Number(firstCharacter);
            const isYear = frequency === yearFrequency;
            const isMonth = frequency === monthFrequency;
            if (isYear) {
                const monthes = controlItems?.filter(e => e.parent === weekOrMonthOrYearId).map(e => e.id);
                const weeks = controlItems?.filter(e => monthes?.includes(e.parent)).map(e => e.id) as number[];
                return weeks || [];
            }
            if (isMonth) {
                const weeks = controlItems?.filter(e => weekOrMonthOrYearId === e.parent).map(e => e.id) as number[];
                return weeks || [];
            }
            return [weekOrMonthOrYearId];
        });
        setCalendarValue(weeksIds);
    }, [controlItems]);


    return <CalendarHierarchy selectableParent label="Calendar" multiple value={calendarDisplayValue} onChange={handlerChange} items={controlItems} />;
};
